import { hasAccessRight } from "../shared/auth/accessRights";

/**
 * Returns whether the synchronization details below the app bar are shown. Entries of the device
 * (unsent or refused) are always reported. Otherwise only people with own time records see them:
 * roles without (billing, for example) never synchronize, and a permanent „Noch nicht
 * synchronisiert“ only raised questions. While the roles are unknown nothing is shown, so the live
 * region does not flash up for those roles (F-57).
 *
 * @param roles - Roles of the person; `undefined` while unknown.
 * @param pending - Entries of the device not yet sent.
 * @param rejected - Entries of the device the server refused.
 * @returns `true` if the details are shown.
 */
export function showsSyncDetails(
  roles: readonly string[] | undefined,
  pending: number,
  rejected: number,
): boolean {
  const shows =
    pending > 0 ||
    rejected > 0 ||
    (roles !== undefined && hasAccessRight(roles, "AccessOwnRecords"));

  return shows;
}
